


























































































import Vue from "vue";
import { Entity, PatientOptions, VerifyPatientsOptions } from "@/types";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class Table extends Vue {
  @Prop() readonly headers: TableHeader[];
  @Prop() readonly items: Entity[];
  @Prop() readonly pagination: Pagination;
  @Prop() readonly options: PatientOptions;
  @Prop() readonly loading: boolean;
  @Prop() readonly itemKey: string;
  @Prop() readonly showSelect: boolean;
  @Prop() readonly select: VerifyPatientsOptions;
  @Prop() readonly groupBy: string;
  //
  order = true;
  sort = "";

  created() {
    this.options.order === "asc" ? (this.order = true) : (this.order = false);
    if (this.options.sort !== "") {
      this.sort = this.recoverySort(this.options.sort);
    }
  }

  renderData = (item: TODO, header: TODO) => {
    let val = "";
    if (header.value.includes(".")) {
      const vals = header.value.split(".");
      val = vals.reduce((acc: TODO, val: TODO) => acc[val], item);
    } else {
      val = item[header.value];
    }
    if (typeof val === "boolean") {
      val = val ? "Yes" : "No";
    }
    return val;
  };
  isNotEmpty() {
    return this.items && this.items.length > 0;
  }

  hasHeader(header: TODO) {
    return header?.value ? true : false;
  }

  fomateOrder(order: string) {
    if (order) {
      this.options.order = `asc`;
    } else {
      this.options.order = `desc`;
    }
    this.$emit("update-table-data");
  }

  fomateSort() {
    const sortDir = {
      姓名: "name",
      性別: "gender",
      ID: "iid",
      信箱: "email"
    };
    this.options.sort = sortDir[this.sort];
    this.$emit("update-table-data");
  }

  recoverySort(key: string) {
    const sortDir = {
      name: "姓名",
      gender: "性別",
      iid: "ID",
      measure: "測量",
      email: "信箱"
    };
    return sortDir[key];
  }
}
